import { withStyles } from "@material-ui/core/styles";

import React from "react";
import {
  Datagrid,
  DateField,
  List,
  ShowButton,
  TextField,
  EditButton,
  TextInput,
  NumberField,
  ReferenceField,
} from "react-admin";

import { MyListActions } from "../__common/MyListActions";
import { MyListPagination } from "../__common/MyListPagination";

const styles = (theme) => ({
  title: {
    maxWidth: "20em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

const filters = [
  <TextInput label="Search" source="code" alwaysOn />,

  <TextInput label="Notes" source="notes" />,
];

export const PhagesList = withStyles(styles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={filters}
    actions={<MyListActions />}
    sort={{ field: "code", order: "ASC" }}
    pagination={<MyListPagination />}
    perPage={100}
  >
    <Datagrid>
      <TextField source="code" />

      <NumberField source="generation" />

      <ReferenceField
        label="Sample"
        resource="phages"
        source="id_sample"
        reference="samples"
        link="show"
      >
        <TextField source="code" />
      </ReferenceField>
      <ReferenceField
        label="Bacteria of isolation"
        resource="phages"
        source="id_bacteria_of_isolation"
        reference="isolates"
        link="show"
      >
        <TextField source="code" />
      </ReferenceField>

      <TextField label="Phage method" source="phage_method" />
      <TextField label="Storage description" source="storage_description" />
      <NumberField label="Amount propagations" source="amount_propagations" />
      <TextField label="Aproximate PFUs" source="aproximate_pfus" />

      <TextField label="Notes" source="notes" />

      <DateField
        source="createdAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <DateField
        source="updatedAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <EditButton />
      <ShowButton />
    </Datagrid>
  </List>
));
